<template>
  <div>
    <div class="content">
      <onboarding-options-picker
        :options="pickerOptions"
        :title="code ? $t('start_learning.start_practice') : $t('start_learning.start_learning')"
        :subtitle="code ? $t('start_learning.you_can_download') : $t('start_learning.or_send_the_email_by_link_sms')"
        :buttonText="$t('school.setup_school.continue')"
        @continueEvent="setupLearning"
        :showDownloadAppLinks="true"
      />
      <div v-if="code && !code.haveOrg" class="picker" id="wait-invite">
        <p>{{ $t('start_learning.to_join_our_organization') }}</p>
        <div class="options">
          <div class="option" @click="openJoinOrganizationModal">
            <img src="@/assets/images/invitation-code.svg" />
            <span>{{ $t('start_learning.enter_invitation_code') }}</span>
          </div>
        </div>
      </div>
    </div>
    <join-organization
      :dialogVisible="modals.joinOrganizationModal"
      v-on:closed="modals.joinOrganizationModal = false"
    />
    <send-email-link
      :dialogVisible="modals.sendEmailLinkModal"
      v-on:closed="modals.sendEmailLinkModal = false"
    />
    <send-sms-link
      :dialogVisible="modals.sendSmsLinkModal"
      v-on:closed="modals.sendSmsLinkModal = false"
    />
  </div>
</template>

<script>
  import OnboardingOptionsPicker from '@/components/common/OnboardingOptionsPicker'
  import JoinOrganization from '@/components/modals/organizations/JoinOrganization'
  import SendEmailLink from '@/components/modals/student/SendEmailLink'
  import SendSmsLink from '@/components/modals/student/SendSmsLink'

  export default {
    components: {
      JoinOrganization,
      SendEmailLink,
      SendSmsLink,
      OnboardingOptionsPicker
    },
    props: {
      code: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        showNotification: false,
        notificationMessage: '',
        modals: {
          joinOrganizationModal: false,
          sendEmailLinkModal: false,
          sendSmsLinkModal: false
        },
        pickerOptions: [
          {
            input: 'email-link',
            image: 'send-email-link.svg',
            name: this.$t('start_learning.send_email_link')
          },
          {
            input: 'sms-link',
            image: 'send-sms-link.svg',
            name: this.$t('start_learning.send_sms_link')
          }
        ]
      }
    },
    mounted() {
      // TODO: this need to be changed
      this.$store.dispatch('user/loadUserData')
    },
    methods: {
      openJoinOrganizationModal() {
        this.modals.joinOrganizationModal = true
      },
      setupLearning(type) {
        this.showNotification = false
        if (type === 'email-link') {
          this.modals.sendEmailLinkModal = true
          this.notificationMessage = this.$t('start_learning.email_link_sent')
        } else {
          this.modals.sendSmsLinkModal = true
          this.notificationMessage = this.$t('start_learning.sms_link_sent')
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../scss/_colors.scss';
  p {
    margin: 0;
    font-size: 18px;
    color: #546873;
    line-height: 1;
    text-align: initial;
  }

  .content {
    display: table;
    margin: 0 auto;
    margin-top: 48px;
    margin-bottom: 30px;
  }

  .elsa-button {
    float: left;
    margin-top: 40px;
  }

  .picker {
    display: flex;
    flex-direction: column;
    p {
      margin-top: 16px;
    }
    button {
      align-self: baseline;
      margin-top: 40px;
    }
    &#wait-invite {
      margin-top: 28px;
      .options {
        display: grid;
        grid-template-columns: 202px;
        cursor: pointer;
      }
    }
  }

  ::v-deep .picker .options {
    grid-template-columns: 320px 320px 320px;
  }
</style>
